import React from "react";
import { Inbox } from "lucide-react";

export const EmptyState = ({ icon: Icon = Inbox, title, description, action }) => (
  <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-card/60 px-6 py-16 text-center">
    <span className="grid h-14 w-14 place-items-center rounded-full bg-muted text-muted-foreground">
      <Icon className="h-6 w-6" />
    </span>
    <h3 className="font-display text-lg font-semibold text-foreground">{title}</h3>
    {description && <p className="max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export const LoadingRows = ({ rows = 5 }) => (
  <div className="space-y-2">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="h-14 animate-pulse rounded-lg bg-muted/70" style={{ animationDelay: `${i * 60}ms` }} />
    ))}
  </div>
);
